import {
  CertIDType,
  CouponStatus,
  CouponTabStatus,
  Gender,
  MemberCardStatus,
  MemberLevel,
  MemberType,
} from '@/config';
import { Ipagination } from '@/utils';
import actionType from '../actions/guest/actionType';

export interface IguestInfo {
  id: number;
  accountType: number | string;
  balance: number; // 储值余额
  buyCardLocation: string; // 会员卡购入地名称
  buyCardLocationType: string; // 会员卡购入地类型【shop-门店
  buyCardStatus: boolean; // 是否购买会员卡
  certNo: string; // 类型
  certType: number; // 证件类型
  availableCoupleCount: number; // 可用券数
  totalCoupleCount: number; // 总券数
  leaveFlag: boolean; // 离店标识
  memberType: MemberType; // 类型
  mobile: string; // 手机号
  email: string;
  name: string; // 姓名
  recNo: string; // 接待单号
  remark: string; // 宾客备注
  roomId: number; // 房间ID
  roomNo: string; // 房号
  sex: Gender; // 性别
  wyuid: string; // 网鱼ID
  canBuyCard: boolean;
  isEditMobile: boolean;
  isEditEmail: boolean;
}

export interface Icoupon {
  couponStoreRangeType?: 0 | 1 | 2;
  bindCommonCode?: string;
  bindCommonName?: string;
  ruleSet?: any;
  couponCondition?: string;
  conditionOrderAmountFloor?: number;
  comment: string; // 描述
  couponCode: string; // 券编号
  couponDescription: string; // 券描述
  couponFaceValue: string; // 券面值
  couponName: string; // 券名称
  couponNo: string; // 券号
  couponSubType: string; // 券子类型
  couponType: string; // 券类型
  endDate: number; // 结束时间
  id: number;
  scope: number; // 范围【1-单店、2-全国
  startDate: number;
  status: CouponStatus; // 状态(0-未绑定 1-已生效 2-锁定 3-已使用 4-已过期 5-已失效)
  storeList: Array<string>; // 门店列表
  usedDate: boolean; // 使用时间
  wyuid: string;
  walkinDisabled: boolean;
  disabled: boolean;
}

export interface Iactivity {
  conditionOrderAmountFloor: string; // 条件订单金额最低值
  promotionCode: string; // 活动code
  promotionDescription: string; // 活动描述
  promotionName: string; // 活动名称
  promotionType: string; // 活动类型
  status: number;
  couponCode?: string;
  couponName?: string;
  couponCount?: number; // 券数量
  joinCountText?: string;
  joinCount?: number;
  ruleSet?: any;
  couponList: Array<any>;
}

type statusCouponItem = {
  couponList: Array<Icoupon>;
  status: CouponTabStatus;
  statusName: string;
};

export interface AccountFlow {
  billType: string; // 业务类型
  commonCode: string; // 门店公用码
  currentPeriodCash: number; // 本期余额
  optionAmount: number; // 操作金额
  orderNo: string; // 订单号
  priorPeriodCash: number; // 上期余额
  serviceTime: number; // 业务发生时间，时间戳
  serviceTradebillNo: string; // 业务流水号
  source: string; // 来源
  tradebillNo: string; // 账务流水号
  wyuid: string; // 用户唯一标识
}

export interface CardItem {
  id: number;
  bindTime: string | number;
  cardCode: string;
  cardName: string;
  name: string;
  cardNo: string;
  commonCode: string;
  endTime: string | number;
  price: number;
  startTime: string | number;
  status: MemberCardStatus;
}

export interface MemberLevelItem {
  accountType: number;
  cardCode: string;
  crsChannelPricingId: number;
  crsChannelPricingName: string;
  icon: string;
  id: number;
  level: number;
  name: string;
  offlineChannelPricingId: number;
  offlineChannelPricingName: string;
  timeCrsChannelPricingId: number;
  timeCrsChannelPricingName: string;
  timeOfflineChannelPricingId: number;
  timeOfflineChannelPricingName: string;
}

export interface BasicCardInfoItem {
  wyuid: string;
  address: string; // 地址
  balance: number; // 余额
  birthday: number; // 生日
  buyCardLocation: string; // 会员购买地
  buyCardTime: number; // 会员办理时间
  cardEndTime: number; // 会员卡结束日期
  cardStartTime: number; // 会员卡起始日期
  certNo: string; // 证件号
  certificateType: CertIDType;
  certificateEndTime: number; // 发证开始时间
  certificateLocation: string; // 证件地址
  certificateStartTime: number; // 发证开始时间
  firstCheckinTime: number; // 首次入住时间
  issuingAuthority: string; // 发证机关
  memberType: number; // 会员类型0：非会员1电酒会员
  mobile: string; // 手机号
  name: string; // 姓名
  nation: string; // 民族
  remark: string; // 备注
  sex: number; // 性别
  xzBalance: number; // 选住余额
  memberLevel: MemberLevel;
  memberCards: Array<CardItem>;
  status: MemberCardStatus; // 会员卡状态
  source: string; // 购卡渠道
  email: string;
  totalCoupleCount: number;
  availableCoupleCount: number;
  points: number;
  availablePoints: number;
  toExpirePoints: number;
  tags: Array<string>; // 宾客标签
}

interface checkinHistoryItem {
  memberType: MemberType;
  commonCode: string;
  commonName: string;
  checkinTime: any;
  checkoutTime: any;
}
type TCheckinHistory = {
  checkinPageList: Array<checkinHistoryItem>;
  checkinPageListLoading: boolean;
} & Pick<Ipagination, 'pageNum' | 'pageSize' | 'total'>;

export type TMemberCardDetail = {
  memberCard: {
    couponInfos: Array<Icoupon>;
    memberDetailMsg: Partial<BasicCardInfoItem>;
    memberCardDetailLoading: boolean;
    price: number;
    lastRefundTime: number;
    totalRefundAmount: number; // 累计退款金额
    nightAuditRefundOrderAndCardStatus: boolean; // 跨夜审退款退卡状态[false-不可退，true-可退]
    refundCardStatus: boolean; // 不退款仅退卡[false-不可退，true-可退]
    refundOrderAndCardStatus: boolean; // 退款退卡状态[false-不可退，true-可退]
  };
};

export type TMemberRechargeDetail = {
  memberRecharge: {
    couponInfos: Array<Icoupon>;
    memberDetailMsg: Partial<BasicCardInfoItem>;
    orderInfo: Partial<{ amount: number; channel: string; shopName: string; shopCode: string }>;
    memberRechargeDetailLoading: boolean;
    lastRefundTime: number;
    totalRefundAmount: number; // 累计退款金额
  };
};

export interface GuestInitialStateProps
  extends Ipagination,
    TMemberCardDetail,
    TMemberRechargeDetail {
  checkinHistory: TCheckinHistory;
  idValidateInfo: { code?: number; data?: any; msg?: string };
  businessList: Array<any>;
  guestKeywordList: Array<IguestInfo>;
  accountFlowList: Array<AccountFlow>;
  basicCardInfo: Partial<BasicCardInfoItem>;
  cardInfoLoading: boolean;
  memberLevelMap: Partial<MemberLevelItem>;
  guestList: Array<IguestInfo>;
  guestDetail: Partial<IguestInfo>;
  currentCacheWyuid: string;
  payOrderNo: string;
  salespersonList: Array<{ saleEmployeeName: string; saleEmployeeNo: string }>;
  activityList: Array<Iactivity>;
  activityPayOrderNo: string;
  availableCouponList: Array<Partial<Icoupon>>;
  optionalDouyinCouponList: Array<any>;
  optionalXuanzhuCouponList: Array<any>;
  optionalWangyuCouponListLoading: boolean;
  optionalDouyinCouponListLoading: boolean;
  optionalXuanzhuCouponListLoading: boolean;
  wangyuCouponList: Array<statusCouponItem>;
  douyinCouponList: Array<any>;
  manualCouponList: Array<any>;
  allWangyuCouponListLoading: boolean;
  allDouyinCouponListLoading: boolean;
  allManualCouponListLoading: boolean;
  buyCardLoading: boolean;
  activityListLoading: boolean;
  activityOrderLoading: boolean;
}
const initialState: GuestInitialStateProps = {
  memberRecharge: {
    couponInfos: [],
    memberDetailMsg: {},
    orderInfo: {},
    memberRechargeDetailLoading: false,
    lastRefundTime: null,
    totalRefundAmount: undefined,
  },
  memberCard: {
    couponInfos: [],
    memberDetailMsg: {},
    memberCardDetailLoading: false,
    price: undefined,
    lastRefundTime: null,
    totalRefundAmount: undefined,
    nightAuditRefundOrderAndCardStatus: false,
    refundCardStatus: false,
    refundOrderAndCardStatus: false,
  },
  checkinHistory: {
    checkinPageList: [],
    checkinPageListLoading: false,
    pageNum: 1,
    pageSize: 50,
    total: 0,
  },
  idValidateInfo: {},
  businessList: [],

  guestKeywordList: [],
  accountFlowList: [],
  basicCardInfo: {},
  cardInfoLoading: false,
  memberLevelMap: {},

  guestList: [],
  guestDetail: {},
  currentCacheWyuid: '',
  payOrderNo: '',
  salespersonList: [],
  activityList: [],
  activityPayOrderNo: '',
  availableCouponList: [],
  optionalDouyinCouponList: [],
  optionalXuanzhuCouponList: [],
  optionalWangyuCouponListLoading: false,
  optionalDouyinCouponListLoading: false,
  optionalXuanzhuCouponListLoading: false,
  wangyuCouponList: [],
  douyinCouponList: [],
  manualCouponList: [],
  allWangyuCouponListLoading: false,
  allDouyinCouponListLoading: false,
  allManualCouponListLoading: false,
  buyCardLoading: false,
  activityListLoading: false,
  activityOrderLoading: false,
  pageNum: 1,
  pageSize: 50,
  total: 0,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionType.CLEAR_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.SAVE_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.SET_PAGINATION:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.TOGGLE_LOADING: {
      const loading = state[action.payload];
      return {
        ...state,
        [action.payload]: !loading,
      };
    }
    case actionType.RESET_PAGINATION:
      return {
        ...state,
        pageNum: 1,
        pageSize: 50,
        total: 0,
      };
    case actionType.UPDATE_ID_VALIDATED_RES:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.GUEST_LIST:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.GET_CARD_PRICE:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.BUY_CARD:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.QUERY_SALES_PERSON:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.COUPON_LIST:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.OPTIONAL_WANGYU_COUPON_LIST:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.OPTIONAL_DOUYIN_COUPON_LIST:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.OPTIONAL_MANUAL_COUPON_LIST:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.ACTIVITY_LIST:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.ACTIVITY_ORDER:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.XUANZHU_COUPON_LIST:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.BUSINESS_PAYMENT_TYPE_LIST:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.GUEST_KEYWORD_LIST:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.ACCOUNT_FLOW_LIST:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.BASIC_CARD_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.MEMBER_LEVEL_MAP:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return {
        ...state,
        ...action.payload,
      };
  }
};
